<template>
  <div class="areaVueSon">
    <div class="content f-absolute-all f-webkit-box">
      <div class="f-w-550 f-webkit-box f-box-vertical">
        <div class="layui-panel f-box-flex1 f-m-b" style="flex: 0.5">
          <div class="jxjb f-h-full">
            <div class="titlebg f-h-full f-webkit-box f-box-vertical f-p-b-sm">
              <div
                class="layui-cards-title f-lh-36 f-color-white f-p-l-xlg f-size-18"
              >
                工业增加值
              </div>
              <div
                class="row f-p-t-lg f-p-b-lg f-b f-m-l-lg f-m-r-lg f-m-t-md f-m-b-md icbgbox"
              >
                <div class="f-webkit-box col-5 f-right">
                  <div class="xgbg2 f-h-full f-info-c">
                    <i class="iconfont f-size-36">&#xe618;</i>
                  </div>
                  <div class="f-m-l-sm">
                    <div class="f-color-white f-size-14">
                      第
                      <span
                        class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                        id="gyzjzpm"
                        >{{
                          gongYeZengJiaZhi.rank == null
                            ? "--"
                            : gongYeZengJiaZhi.rank
                        }}</span
                      >名
                    </div>
                    <div class="f-color-2f85b1 f-size-14">全市排名</div>
                  </div>
                </div>
                <div class="f-webkit-box col-6 f-right">
                  <div class="xgbg2 f-h-full">
                    <i class="iconfont icon1"></i>
                  </div>
                  <div class="f-m-l-sm">
                    <div
                      class="f-color-white f-size-14"
                      :class="
                        gongYeZengJiaZhi.growth < 0 ? 'downicon' : 'upicon'
                      "
                    >
                      <span
                        class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                        id="gyzjz"
                        >{{
                          gongYeZengJiaZhi.growth == null
                            ? "--"
                            : gongYeZengJiaZhi.growth
                        }}</span
                      >%
                    </div>
                    <div class="f-color-2f85b1 f-size-14">累计同比增速</div>
                  </div>
                </div>
              </div>
              <div class="f-webkit-box f-m-l-lg f-m-r-lg">
                <div class="layui-cutline f-box-flex1"></div>
                <div
                  class="layui-cutline f-box-flex1"
                  layui-front="false"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div class="layui-panel f-p-xxs" style="flex: 1.4">
          <div class="jxjb f-h-full f-p-b">
            <div class="titlebg f-h-full">
              <div
                class="layui-cards-title f-lh-36 f-color-white f-p-l-xlg f-size-18"
              >
                园区概况
              </div>
              <div
                class="f-p-l-md f-p-r-md f-p-t-sm f-p-b-xlg cbg"
                style="height: 100%"
              >
                <table class="f-w-full yqlist">
                  <colgroup>
                    <col width="90" />
                    <col width="163" />
                    <col width="90" />
                    <col width="163" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td class="f-info-c" valign="middle">
                        <i class="iconfont f-size-42 icon-color1">&#xe61a;</i>
                      </td>
                      <td>
                        <div class="'f-size-12 txt-color1 f-bold">
                          <span
                            class="f-size-26 txt-color1 f-normal"
                            id="zhnh"
                            >{{ yuanQuGaiKuangChanZhi.sum }}</span
                          >
                          {{ yuanQuGaiKuangChanZhi.unit }}
                        </div>
                        <div class="f-color-1e93cf f-size-14 f-p-t-xs">
                          {{ yuanQuGaiKuangChanZhi.target }}
                        </div>
                      </td>
                      <td class="f-info-c" valign="middle">
                        <i class="iconfont f-size-42 icon-color1">&#xe725;</i>
                      </td>
                      <td>
                        <div class="'f-size-12 txt-color2 f-bold">
                          <span
                            class="f-size-26 txt-color2 f-normal"
                            id="gyhs"
                            >{{ yuanQuGaiKuangQiYeShu.sum }}</span
                          >
                          {{ yuanQuGaiKuangQiYeShu.unit }}
                        </div>
                        <div class="f-color-1e93cf f-size-14 f-p-t-xs">
                          {{ yuanQuGaiKuangQiYeShu.target }}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="f-info-c" valign="middle">
                        <i class="iconfont f-size-42 icon-color1">&#xe61a;</i>
                      </td>
                      <td>
                        <div class="'f-size-12 txt-color3 f-bold">
                          <span
                            class="f-size-26 txt-color3 f-normal"
                            id="fspf"
                            >{{ yuanQuGaiKuangRenYuanShu.sum }}</span
                          >
                          {{ yuanQuGaiKuangRenYuanShu.unit }}
                        </div>
                        <div class="f-color-1e93cf f-size-14 f-p-t-xs">
                          {{ yuanQuGaiKuangRenYuanShu.target }}
                        </div>
                      </td>
                      <td class="f-info-c" valign="middle">
                        <i class="iconfont f-size-42 icon-color4">&#xe66e;</i>
                      </td>
                      <td>
                        <div class="'f-size-12 txt-color4 f-bold">
                          <span
                            class="f-size-26 txt-color4 f-normal"
                            id="gygtfw"
                            >{{ yuanQuGaiKuangLiRun.sum }}</span
                          >
                          {{ yuanQuGaiKuangLiRun.unit }}
                        </div>
                        <div class="f-color-1e93cf f-size-14 f-p-t-xs">
                          {{ yuanQuGaiKuangLiRun.target }}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="f-info-c" valign="middle">
                        <i class="iconfont f-size-42 icon-color4">&#xe66e;</i>
                      </td>
                      <td>
                        <div class="'f-size-12 txt-color1 f-bold">
                          <span
                            class="f-size-26 txt-color1 f-normal"
                            id="gyqy"
                            >{{ yuanQuGaiKuangTouZiE.sum }}</span
                          >
                          {{ yuanQuGaiKuangTouZiE.unit }}
                        </div>
                        <div class="f-color-1e93cf f-size-14 f-p-t-xs">
                          {{ yuanQuGaiKuangTouZiE.target }}
                        </div>
                      </td>
                      <td class="f-info-c" valign="middle">
                        <i class="iconfont f-size-42 icon-color3">&#xe671;</i>
                      </td>
                      <td>
                        <div class="'f-size-12 txt-color3 f-bold">
                          <span
                            class="f-size-26 txt-color3 f-normal"
                            id="yysr"
                            >{{ yuanQuGaiKuangShuiJin.sum }}</span
                          >
                          {{ yuanQuGaiKuangShuiJin.unit }}
                        </div>
                        <div class="f-color-1e93cf f-size-14 f-p-t-xs">
                          {{ yuanQuGaiKuangShuiJin.target }}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="f-info-c" valign="middle">
                        <i class="iconfont f-size-42 icon-color4">&#xe66e;</i>
                      </td>
                      <td>
                        <div class="'f-size-12 txt-color4 f-bold">
                          <span
                            class="f-size-26 txt-color4 f-normal"
                            id="jcss"
                            >{{ yuanQuGaiKuangShouRu.sum }}</span
                          >
                          {{ yuanQuGaiKuangShouRu.unit }}
                        </div>
                        <div class="f-color-1e93cf f-size-14 f-p-t-xs">
                          {{ yuanQuGaiKuangShouRu.target }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="f-box-flex1 f-m-l f-m-r f-webkit-box f-box-vertical">
        <div class="layui-panel f-box-flex1 f-m-b">
          <div class="f-h-full f-webkit-box f-box-vertical f-relative centerbg">
            <div class="ctpnav">
              <div
                class="layui-cards-title f-lh-32 f-color-white f-p-l-xlg f-size-18"
                id="municipal"
              >
                [ {{ mapName }} ]
                <!-- 全市经济发展情况 -->
              </div>
              <!-- <div class="ctnavbox">
                <div
                  class="ctnav-item"
                  v-for="(item,index) in tabsParam"
                  :key="index"
                  @click="toggleTabs(index)"
                  :class="{active:index!=nowIndex}"
                >{{item}}</div>
              </div>-->
            </div>
            <div class="f-box-flex1 f-m" id="mapBox"></div>
          </div>
        </div>
        <div class="layui-panel f-h-350">
          <div class="titlebg f-h-full f-webkit-box f-box-vertical f-p-b-sm">
            <div
              class="layui-cards-title f-lh-36 f-color-white f-p-l-xlg f-size-18 f-m-b-sm"
            >
              区县统计
            </div>
            <div
              class="row f-p-t-lg f-p-b-lg f-b f-m-l-lg f-m-r-lg f-m-t-md f-m-b-md icbgbox f-box-flex1 f-webkit-box f-box-vertical f-box-pack-c"
            >
              <div class="f-webkit-box f-box-space-around">
                <div class="f-webkit-box f-p-b f-m-w">
                  <div class="xgbg2 f-h-full f-info-c f-p-t-xs">
                    <i class="iconfont f-size-28">&#xe671;</i>
                  </div>
                  <div class="f-m-l-sm">
                    <div class="f-color-white f-size-14">
                      <span
                        class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                        id="zyyw"
                        >{{
                          quanShiTongJi.busCount == null
                            ? "--"
                            : quanShiTongJi.busCount
                        }}</span
                      >亿元
                    </div>
                    <div class="f-color-2f85b1 f-size-14">主营业务收入累计</div>
                  </div>
                </div>
                <div class="f-webkit-box f-p-b f-m-w">
                  <div class="xgbg2 f-h-full f-info-c">
                    <i class="iconfont icon1"></i>
                  </div>
                  <div class="f-m-l-sm">
                    <div class="f-color-white f-size-14">
                      <span
                        class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                        id="lrze"
                        >{{
                          quanShiTongJi.profitCount == null
                            ? "--"
                            : quanShiTongJi.profitCount
                        }}</span
                      >亿元
                    </div>
                    <div class="f-color-2f85b1 f-size-14">利润总额累计</div>
                  </div>
                </div>
              </div>
              <div class="f-webkit-box f-box-space-around">
                <div class="f-webkit-box f-p-t f-m-w">
                  <div class="xgbg2 f-h-full f-info-c">
                    <i class="iconfont f-size-28">&#xe665;</i>
                  </div>
                  <div class="f-m-l-sm">
                    <div class="f-color-white f-size-14">
                      <span
                        class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                        id="yqs"
                        >{{ quanShiTongJi.parkLibrary }}</span
                      >个
                    </div>
                    <div class="f-color-2f85b1 f-size-14">园区数</div>
                  </div>
                </div>
                <div class="f-webkit-box f-p-t f-m-w">
                  <div class="xgbg2 f-h-full f-info-c">
                    <i class="iconfont f-size-36">&#xe6cd;</i>
                  </div>
                  <div class="f-m-l-sm">
                    <div class="f-color-white f-size-14">
                      <span
                        class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                        id="qys"
                        >{{ quanShiTongJi.company }}</span
                      >个
                    </div>
                    <div class="f-color-2f85b1 f-size-14">企业数</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="f-w-550 f-webkit-box f-box-vertical">
        <div class="layui-panel f-p-xxs f-box-flex1 f-m-b">
          <div class="titlebg f-h-full f-webkit-box f-box-vertical f-p-b-sm">
            <div
              class="layui-cards-title f-lh-36 f-color-white f-p-l-xlg f-size-18"
            >
              工业投资
            </div>
            <div
              class="row f-p-t-lg f-p-b-lg f-b f-m-l-lg f-m-r-lg f-m-t-md f-m-b-sm icbgbox"
            >
              <div class="f-webkit-box col-5 f-right">
                <div class="xgbg2 f-h-full f-info-c">
                  <i class="iconfont f-size-36">&#xe618;</i>
                </div>
                <div class="f-m-l-sm">
                  <div class="f-color-white f-size-14">
                    第
                    <span
                      class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                      id="qspm"
                      >{{
                        gongYeTouZi.rank == null ? "--" : gongYeTouZi.rank
                      }}</span
                    >名
                  </div>
                  <div class="f-color-2f85b1 f-size-14">全市排名</div>
                </div>
              </div>
              <div class="f-webkit-box col-6 f-right">
                <div class="xgbg2 f-h-full">
                  <i class="iconfont icon1"></i>
                </div>
                <div class="f-m-l-sm">
                  <div
                    class="f-color-white f-size-14"
                    :class="gongYeTouZi.growth < 0 ? 'downicon' : 'upicon'"
                  >
                    <span
                      class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                      id="lgtbzs"
                      >{{
                        gongYeTouZi.growth == null ? "--" : gongYeTouZi.growth
                      }}</span
                    >%
                  </div>
                  <div class="f-color-2f85b1 f-size-14">累计同比增速</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="layui-panel f-p-xxs f-h-350">
          <div class="titlebg f-h-full f-webkit-box f-box-vertical f-p-b-sm">
            <div
              class="layui-cards-title f-lh-36 f-color-white f-p-l-xlg f-size-18"
            >
              重点企业生产情况TOP5
              <span class="f-color-72a8db f-right f-m-r-xlg">单位：万元</span>
            </div>
            <div class="f-p-l-sm f-p-r-sm">
              <table
                class="layui-table f-m-n tp5 f-bg-none f-b-n"
                lay-even
                lay-skin="line"
                lay-size="sm"
                cellpadding="10"
              >
                <colgroup>
                  <col width="45" />
                  <col />
                  <col width="110" />
                  <col width="110" />
                  <col width="110" />
                </colgroup>
                <thead>
                  <tr class="f-bg-none-i">
                    <th></th>
                    <th>重点企业名称</th>
                    <th class="f-info-c">工业总产值</th>
                    <th class="f-info-c">销售收入</th>
                    <th class="f-info-c">利润</th>
                  </tr>
                </thead>
                <tbody id="zdTop5" v-html="showHtml"></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "../bus.js";

export default {
  name: "areaVueSon",
  props: ["searchYearMonth"],
  data() {
    return {
      tabsParam: ["增加值增速", "工业投资增速"],
      nowIndex: 0, //默认第一个tab为激活状态
      mapCode: this.$route.query.code,
      mapName: this.$route.query.name,
      month: this.searchYearMonth,
      navText: "444",
      showHtml: "",
      gongYeZengJiaZhi: {},
      quanShiTongJi: {},
      gongYeTouZi: {
        rank: null,
        name: "",
        growth: null,
      },
      zhongDianQiYe: [],
      yuanQuGaiKuang: [],
      yuanQuGaiKuangChanZhi: {},
      yuanQuGaiKuangQiYeShu: {},
      yuanQuGaiKuangRenYuanShu: {},
      yuanQuGaiKuangLiRun: {},
      yuanQuGaiKuangTouZiE: {},
      yuanQuGaiKuangShuiJin: {},
      yuanQuGaiKuangShouRu: {},
    };
  },
  components: {},
  watch: {
    searchYearMonth: function (val) {
      this.month = val;
      this.getData(this.month);
    },
  },
  created() {
    this.getCurrentDateTime();
  },
  mounted() {
    let routerpath = this.$route.query.name;
    this.Dmap();
    Bus.$emit("valdd", { name: routerpath, path: "/areavue" });
    this.getData(this.month);
    this.getIndexYearMonth(this.month);
  },
  methods: {
    getIndexYearMonth(value) {
      this.$emit("getYearMonth", value);
    },
    getCurrentDateTime() {
      var d = new Date();
      var year = d.getFullYear();
      var month = d.getMonth() + 1;

      if (month < 10) {
        month = "0" + month;
      }
      var YM = year + "-" + month;
      this.getData(YM);
    },
    /*'增加值增速','工业投资增速'  切换开始*/
    toggleTabs: function (index) {
      this.nowIndex = index;
    },
    /*'增加值增速','工业投资增速'  切换结束*/

    getData(month) {
      //工业增速和排名
      this.$axios
        .get("/business/monitor/area/selectIndustryGrowthByDistrict", {
          params: {
            dateRange: month,
            districtName: this.mapName,
          },
        })
        .then((res) => {
          if (res.data.data) {
            this.gongYeZengJiaZhi = res.data.data;
          } else {
            this.gongYeZengJiaZhi.rank = null;
            this.gongYeZengJiaZhi.growth = null;
          }
        });
      //园区概况
      this.$axios
        .get("/business/monitor/area/selectParkOverviewByDistrict", {
          params: {
            dateRange: month,
            districtName: this.mapName,
          },
        })
        .then((res) => {
          if (res.data.data.length > 0) {
            this.yuanQuGaiKuang = res.data.data;
            this.yuanQuGaiKuangChanZhi = res.data.data[0];
            this.yuanQuGaiKuangQiYeShu = res.data.data[1];
            this.yuanQuGaiKuangRenYuanShu = res.data.data[2];
            this.yuanQuGaiKuangLiRun = res.data.data[3];
            this.yuanQuGaiKuangTouZiE = res.data.data[4];
            this.yuanQuGaiKuangShuiJin = res.data.data[5];
            this.yuanQuGaiKuangShouRu = res.data.data[6];
          }
        });
      //区县统计
      this.$axios
        .get("/business/monitor/area/selectDistrictTotal", {
          params: {
            dateRange: month,
            districtName: this.mapName,
          },
        })
        .then((res) => {
          this.quanShiTongJi = res.data.data;
        });
      //工业投资
      this.$axios
        .get("/business/monitor/area/selectIndustryInvestByDistrict", {
          params: {
            dateRange: month,
            districtName: this.mapName,
          },
        })
        .then((res) => {
          if (res.data.data) {
            this.gongYeTouZi = res.data.data;
          } else {
            this.gongYeTouZi.rank = null;
            this.gongYeTouZi.growth = null;
          }
        });
      //区县重点企业生产情况top5
      this.$axios
        .get("/business/monitor/area/selectKeyEnterpriseByDistrict", {
          params: {
            dateRange: month,
            districtName: this.mapName,
          },
        })
        .then((res) => {
          this.zhongDianQiYe = res.data.data;
          var data = res.data.data;
          if (data) {
            for (var i = 0; i < data.length; i++) {
              this.showHtml =
                "<tr style='height:52px'>" +
                "<td class='f-info-c'><div class='serial'>" +
                (i + 1) +
                "</div></td>" +
                "<td class='f-color-72a8db'>" +
                data[i].name +
                "</td>" +
                "<td class='f-info-c f-color-white'>" +
                (data[i].industryOutput >= 0
                  ? "<i class='iconfont f-color-up'>&#xe66f;</i>"
                  : "<i class='iconfont f-color-down'>&#xeef6;</i>") +
                data[i].industryOutput.toFixed(2) +
                "</td>" +
                "<td class='f-info-c f-color-white'>" +
                (data[i].saleRevenue >= 0
                  ? "<i class='iconfont f-color-up'>&#xe66f;</i>"
                  : "<i class='iconfont f-color-down'>&#xeef6;</i>") +
                data[i].saleRevenue.toFixed(2) +
                "</td>" +
                "<td class='f-info-c f-color-white'>" +
                (data[i].profit >= 0
                  ? "<i class='iconfont f-color-up'>&#xe66f;</i>"
                  : "<i class='iconfont f-color-down'>&#xeef6;</i>") +
                data[i].profit.toFixed(2) +
                "</td>" +
                "</tr>";
            }
          }
        });
    },

    Dmap() {
      var _this = this;
      _this.$axios
        .get(`/system/config/selectRegionAndVersion`)
        .then((result) => {
          if (result.data.data.region && result.data.data.version) {
            _this.$axios
              .get(
                `/system/config/selectConfigByRegionAndKeyAndVersion?region=${result.data.data.region}&key=json.url&version=${result.data.data.version}`
              )
              .then((result) => {
                var url = `${result.data.data.value}${_this.mapCode}.json`;

                var data = {
                  title: "工业增加值同比",
                  map: url,
                  data: [],
                };
                this.map("mapBox", data);
              });
          } else {
            return;
          }
        });
    },

    map(id, data) {
      let chart = this.$echarts.init(document.getElementById(id));
      var lines = [],
        series = [],
        layoutSize = "100%";
      this.$http.get(data.map).then((mapjson) => {
        this.$echarts.registerMap("mapname", mapjson.data);
        var option = {
          geo: {
            map: "mapname",
            layoutCenter: ["50%", "50%"],
            layoutSize: layoutSize,
            label: {
              normal: {
                show: true,
                textStyle: {
                  fontSize: 18,
                  fontWeight: "bold",
                  color: "#000",
                },
              },
              emphasis: {
                show: false,
              },
            },
            itemStyle: {
              areaColor: "#90c31d",
              borderWidth: 1.5,
              borderColor: "#317ff8",
              fontSize: 20,
            },
            emphasis: {
              label: {
                areaColor: "#90c31d",
              },
            },
          },
          series: series,
        };
        chart.setOption(option, true);
      });
      return chart;
    },
  },
};
</script>

<style scoped>
.content {
  top: 80px;
  padding: 15px 20px;
}

.layui-panel {
  background: url(../../../assets/img/bg001.png) center no-repeat;
  background-size: 100% 100%;
}

.layui-cards-title {
  background: url(../../../assets/img/jiantou.png) no-repeat;
}

.bg002 {
  background: url(../../../assets/img/bg002.png) center no-repeat;
  background-size: 100% 100%;
}

.f-right {
  height: 66px;
}
</style>